import axios from 'axios';
import moment from 'moment';

// fetch Reports list
export async function fetchAccountingReports() {
	let details = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/reportslist`,
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}

	return details;
}

// search param api
export async function fetchParams(docID) {
	let details = [];

	try {
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}reports/getparameters/`,
			data: { docID },
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function fetchCompanyLov() {
	let customerList = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/customerslist/`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		customerList = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return customerList;
}

export async function fetchAgentLov() {
	let agentList = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/agentslist/`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		agentList = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return agentList;
}

export async function fetchGeneratedReports(docID) {
	let details = [];

	try {
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}reports/generatedreports/`,
			data: { docID },
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateAr(userID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');
	
	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			// url: `${process.env.REACT_APP_BACKEND_API}reports/arPerClient?userID=${userID}&customerID=${customerID}&fromDate=${fromDate}&toDate=${toDate}`,
			url: `${process.env.REACT_APP_BACKEND_API}reports/ar`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, fromDate, toDate }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateArPerClient(userID, customerID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');
	
	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/arPerClient?userID=${userID}&customerID=${customerID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateArSummary(userID, asOfDate) {
	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/arSummary?userID=${userID}&asOfDate=${asOfDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateBirSalesRep(userID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/birSales?userID=${userID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateColReport(userID, dateRange){
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/coll`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, fromDate, toDate }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateColRepPerClient(userID, customerID, dateRange){
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/colRepPerClient?userID=${userID}&customerID=${customerID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateColRepPerWeek(userID, dateFrom, dateTo){
	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/colRepPerWeek?userID=${userID}&dateFrom=${dateFrom}&dateTo=${dateTo}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateColRepPerMonth(userID, monthYear) {
	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/colRepPerMonth?userID=${userID}&monthYear=${monthYear}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateColRepPerPayDate(userID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');
	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/colRepPerPayDate?userID=${userID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateColRepSummary(userID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/colRepSmry?userID=${userID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateRepAgentPerMonth(userID, agent_code, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/comRepAgentPerMonth?userID=${userID}&agent_code=${agent_code}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateOrSeries(userID, dateRange ) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/orSeries?userID=${userID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateDrSeries(userID, drNoFrom, drNoTo) {
	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/drSeries`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, drNoFrom, drNoTo }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateUnbilledDr(userID, dateRange) {
	console.log("🚀 ~ generateUnbilledDr ~ dateRange:", dateRange)
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/drUnbilled?userID=${userID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateDrClientDelivery(userID, customerID, dateRange) {
	console.log("🚀 ~ generateDrClientDelivery ~ customerID:", customerID, "dateRange:", dateRange)
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/drClientDelivery?userID=${userID}&customerID=${customerID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateConsolidatedDateRange(userID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/consolidatedDateRange`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, fromDate, toDate }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
	}
	return details;
}

export async function generateConsolidatedCustomer(userID, customerID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/consolidatedCustomer`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, customerID, fromDate, toDate }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
	}
	return details;
}

export async function generateConsolidatedAgent(userID, agentCode, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/consolidatedAgent`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, agentCode, fromDate, toDate }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
	}
	return details;
}

export async function generateArSummArPerClientCombined(userID, dateRange, customerID) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/arSummaryPerClientCombined`,
			headers: {
				'content-type': 'application/json',
			},
			params: {
				userID,
				fromDate,
				toDate,
				...(customerID ? { customerID } : {})
			}
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
	}
	return details;
}


export async function generateSalesReport(userID, customerID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/sales`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, customerID, fromDate, toDate }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateSalesRepPerClientMonth(userID, customerID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/salesRepPerClientMonth?userID=${userID}&customerID=${customerID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateSalesRepPerAgentMonth(userID, customer_id, agentCode, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/salesRepPerAgentMonth?userID=${userID}&customer_id=${customer_id}&agentCode=${agentCode}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateSalesRepPerMonthBr(userID, customerID, dateRange) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/salesRepPerMonthBr?userID=${userID}&customerID=${customerID}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}


export async function generateSoa(userID, customer_id, agent_code, dateRange ) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/soa?userID=${userID}&customer_id=${customer_id}&agent_code=${agent_code}&fromDate=${fromDate}&toDate=${toDate}`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function generateArAging(userID, dateRange ) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/arAging`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, fromDate, toDate }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}


export async function generateArAgingPerClient(userID, customer_id, dateRange ) {
	const fromDate = dateRange === undefined ? '' : moment(dateRange[0]).format('MM-DD-YYYY');
	const toDate = dateRange === undefined ? '' : moment(dateRange[1]).format('MM-DD-YYYY');

	let details = [];
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}reports/arAgingPerClient`,
			headers: {
				'content-type': 'application/json',
			},
			params: { userID, customer_id, fromDate, toDate }
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return details;
}

